import { Arrow, UserArrow } from '../ChessBoard';

// Правило рисования поверх нарисованных стрелок: та же стрелка тем же цветом —
// снимается, другим цветом — перекрашивается, новая — добавляется. Чужие
// стрелки (движка) в результат не попадают: рисуются только пользовательские
export function toggleUserArrow(
  arrows: readonly Arrow[] | undefined,
  arrow: UserArrow,
): UserArrow[] | undefined {
  const userArrows = arrows?.filter((a): a is UserArrow => a.type === 'user') ?? [];
  const duplicate = userArrows.find((a) => a.to === arrow.to && a.from === arrow.from);

  if (!duplicate) return [...userArrows, arrow];

  const next = userArrows.filter((a) => a !== duplicate);
  if (duplicate.color !== arrow.color) next.push(arrow);
  return next.length ? next : undefined;
}
